import Logo from '../logos/vaillantsim';

export default Logo;
